<template>
  <label class="gp-checkbox-wrap" :class="[`size-${size}`,  `align-items-{${align}}`]" :size="size">
    <div class="checkmark-wrapper">
      <i class="checkmark" :class="{ 'icon icon-check checked': isChecked }" :size="size"></i>
    </div>
    <span class="gp-checkbox-text">{{ label }}</span>
    <input class="checkbox" type="checkbox" :checked="isChecked" :value="value" @change="updateInput" />
  </label>
</template>

<script>
export default {
  name: "GpCheckbox",
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    value: { type: String },
    modelValue: { default: "" },
    label: { type: String, required: true },
    trueValue: { default: true },
    falseValue: { default: false },
    size: { default: "medium"},
    align: { default: "center"}
  },
  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value);
      }
      // Note that `true-value` and `false-value` are camelCase in the JS
      return this.modelValue === this.trueValue;
    }
  },
  methods: {
    updateInput(event) {
      let isChecked = event.target.checked;
      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue];
        if (isChecked) {
          newValue.push(this.value);
        } else {
          newValue.splice(newValue.indexOf(this.value), 1);
        }
        this.$emit("change", newValue);
      } else {
        const valueEmit = isChecked ? true : false;
        this.$emit("change", valueEmit);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* Customize the label (the wrapper) */
.gp-checkbox-wrap {
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 6px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 16px;
  margin: 0;
  &.size-medium{
    .checkmark-wrapper {
      width: 24px;
      height: 24px;
    }
    .checkmark {
      height: 20px;
      width: 20px;
    }
    .gp-checkbox-text{
      margin-left: 8px;
      width: calc(100% - 21px);
    }
  }
  &.size-small{

    .checkmark-wrapper {
      width: 20px;
      height: 20px;
    }
    .checkmark {
      height: 16px;
      width: 16px;
      font-size: 9px;
    }
    .gp-checkbox-text{
      margin-left: 8px;
      width: calc(100% - 16px);
    }
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .checkmark {
    box-sizing: border-box;
    height: 21px;
    width: 21px;
    border-radius: 3px;
    background-color: $light1;
    border: 1px solid $dark6;
    font-weight: 700;
    font-size: 11px;
    color: $light1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &.gp-checkbox-wrap:hover .checkmark {
    background-color: $light1;
    border-color: $textLightModeLow;
  }
  &.gp-checkbox-wrap .checkmark.checked {
    background-color: $mono3;
    border-color: $mono3;
  }
}

.gp-checkbox-text {
    font-family: inherit;
  }
</style>
